import cssPane from '../../wordPane.module.scss';
import css from './deVerbValue.module.scss';

import { memo, useState } from 'react';

import useDynamicFontSize from 'core/hooks/browser/useDynamicFontSize';

import Grid from './VerbGrid';

type TProps = { word: TWord; disabled: boolean };

const DeVerbValuePane = ({ word }: TProps) => {
  const [container, setContainer] = useState<HTMLElement | null>(null);
  const { style } = useDynamicFontSize(container, 'value-pane');

  return (
    <div
      ref={setContainer}
      style={style}
      className={`${cssPane.wordSplitPane} ${css.deVerbValuePane}`}
    >
      <Grid showAnswer={true} value={word.value} />
    </div>
  );
};

export default memo(DeVerbValuePane);
